var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title" }, [_vm._v("面辅料信息")]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.bomActive,
            callback: function ($$v) {
              _vm.bomActive = $$v
            },
            expression: "bomActive",
          },
        },
        _vm._l(_vm.materialColorDataVoList, function (item, index) {
          return _c(
            "el-tab-pane",
            {
              key: index,
              attrs: { label: item.colorName, name: String(index) },
            },
            [
              _c(
                "div",
                [
                  _c("div", { staticClass: "tableHeader" }, [_vm._v("面料")]),
                  _vm._v(" "),
                  _c("BomInformation", {
                    attrs: { datas: item.fabricList ? item.fabricList : [] },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "tableHeader" }, [_vm._v("里料")]),
                  _vm._v(" "),
                  _c("BomFabirc", {
                    attrs: {
                      datas: item.insideFabricList ? item.insideFabricList : [],
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "tableHeader" }, [_vm._v("辅料")]),
                  _vm._v(" "),
                  _c("BomFabirc", {
                    attrs: {
                      datas: item.accessoriesList ? item.accessoriesList : [],
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "tableHeader" }, [
                    _vm._v("共用耗材"),
                  ]),
                  _vm._v(" "),
                  _c("BomFabirc", {
                    attrs: {
                      datas: item.suppliesList ? item.suppliesList : [],
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }